import { Outlet } from 'react-router-dom';
import { Stack } from '@mui/material';
import Header from './components/Header';
import SideBar from './components/Sidebar';
import { useLocation } from 'react-router-dom';
import GoogleMapModal from './components/GoogleMapModal';
import { useGoogleMap } from './components/GoogleMapContext';
const Layout = () => {
  const location = useLocation();
  const hidePages = [
    '/login',
    '',
    '/',
    '/quote-dashboard/quote/Add',
    '/data-management/labour/Add',
    '/data-management/mobile-assets/Add',
  ];
  const pathLinks = location.pathname.split('/').map((link: any) => {
    return {
      title: link === '' ? 'Home' : link.toLowerCase().replaceAll('-', ' '),
      link: link,
    };
  });

  const shouldShowLayout =
    hidePages.includes(location.pathname) ||
    location.pathname.startsWith('/data-management/labour/') ||
    location.pathname.startsWith('/quote-dashboard/quote/') ||
    location.pathname.startsWith('/data-management/mobile-assets/');

  return (
    <Stack>
      {!shouldShowLayout && <Header onSearch={() => {}} links={pathLinks} />}
      {!shouldShowLayout && <SideBar />}
      <Outlet />
    </Stack>
  );
};

export default Layout;
